import { memo } from 'react'

const SectionDivider = () => {
    return (
        <div className="my-4 border-t border-gray-300 dark:border-gray-300 mx-2"></div>
    )
}

export default memo(SectionDivider)
